const shineSharpSVG = (color = '#ffffff') => `
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
        d="M7 0L8.09277 2.95316C8.59919 4.32175 9.67825 5.40081 11.0468 5.90723L14 7L11.0468 8.09277C9.67824 8.59919 8.59919 9.67825 8.09277 11.0468L7 14L5.90723 11.0468C5.40081 9.67824 4.32175 8.59919 2.95316 8.09277L0 7L2.95316 5.90723C4.32175 5.40081 5.40081 4.32175 5.90723 2.95316L7 0Z" 
        fill="${color}"
    />
</svg>
`

export default shineSharpSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/shineSharpSVG.js